import { render, staticRenderFns } from "./HomeButtons.vue?vue&type=template&id=66b74000&"
import script from "./HomeButtons.vue?vue&type=script&lang=js&"
export * from "./HomeButtons.vue?vue&type=script&lang=js&"
import style0 from "./HomeButtons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports